export const TASK_PRICE_TYPES = {
  STANDARD: 'standard',
  ADDON: 'addon'
}

export const TASK_PRICE_TYPE_OPTIONS = [
  { value: TASK_PRICE_TYPES.STANDARD, label: 'Standard Pricing' },
  { value: TASK_PRICE_TYPES.ADDON, label: 'Add-On' }
]

/**
 * Resolve the sell price for a task given a price type and optional calculated fallback.
 * Standard uses sell_price when set; add-on uses addon_sell_price when set.
 */
export function resolveTaskSellPrice (task, priceType, calculatedPrice) {
  const standardOverride = task && task.sell_price != null && task.sell_price !== ''
    ? parseFloat(task.sell_price)
    : NaN
  const addonOverride = task && task.addon_sell_price != null && task.addon_sell_price !== ''
    ? parseFloat(task.addon_sell_price)
    : NaN
  const calculated = calculatedPrice != null && calculatedPrice !== ''
    ? parseFloat(calculatedPrice)
    : NaN

  if (priceType === TASK_PRICE_TYPES.ADDON) {
    if (Number.isFinite(addonOverride) && addonOverride > 0) return addonOverride
    if (Number.isFinite(calculated) && calculated > 0) return calculated
    if (Number.isFinite(standardOverride) && standardOverride > 0) return standardOverride
    return 0
  }

  if (Number.isFinite(standardOverride) && standardOverride > 0) return standardOverride
  if (Number.isFinite(calculated) && calculated > 0) return calculated
  return 0
}

export function normalizeTaskPriceType (value) {
  return value === TASK_PRICE_TYPES.ADDON ? TASK_PRICE_TYPES.ADDON : TASK_PRICE_TYPES.STANDARD
}
